export var Operator;
(function (Operator) {
    Operator["AbsIsMoreThan"] = "absIsMoreThan";
    Operator["DecreasedByMoreThan"] = "decreasedByMoreThan";
    Operator["IncreasedByMoreThan"] = "increasedByMoreThan";
    Operator["Below"] = "below";
    Operator["Over"] = "over";
})(Operator || (Operator = {}));
export const OperatorKey = {
    increasedByMoreThan: 'OPERATOR.INCREASE',
    decreasedByMoreThan: 'OPERATOR.DECREASE',
    absIsMoreThan: 'OPERATOR.INCREASE_OR_DECREASE',
    over: 'OPERATOR.OVER',
    below: 'OPERATOR.BELOW',
};
export const OperatorSign = {
    [Operator.AbsIsMoreThan]: '+/-',
    [Operator.DecreasedByMoreThan]: '-',
    [Operator.IncreasedByMoreThan]: '+',
    [Operator.Below]: '<',
    [Operator.Over]: '>',
};
//# sourceMappingURL=operator.js.map